"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.setSelectedVersion = exports.setAssetVersions = exports.openVersionCommentsModal = exports.closeVersionCommentsModal = exports.assetVersionSlice = exports.deleteComment = exports.fetchAssetVersionComments = exports.fetchAssetVersions = void 0;
const pulse_components_1 = require("@pcs/pulse-components");
const toolkit_1 = require("@reduxjs/toolkit");
const utilities_1 = __importDefault(require("jsAssets/utilities"));
const initialState = {
    comments: [],
    isLoadingVersionComments: false,
    isLoadingVersions: false,
    isVersionCommentModalOpen: false,
    selectedVersion: null,
    versions: [],
};
exports.fetchAssetVersions = (0, toolkit_1.createAsyncThunk)('assetVersion/fetchVersions', async (payload, { getState }) => {
    const { assetDetail: { asset }, } = getState();
    if (!asset) {
        throw new Error('Missin asset in asset detail slice');
    }
    const { assetId } = { ...asset };
    const response = await pulse_components_1.v2Endpoint
        .get(window.pulse.config.urls.api, {
        params: {
            action: 'files',
            type: 'versionHistory',
            assetId,
        },
    })
        .then((res) => {
        return res.data.data;
    })
        .catch(() => {
        utilities_1.default.notification.danger('Failed to fetch asset versions');
    });
    return response;
});
exports.fetchAssetVersionComments = (0, toolkit_1.createAsyncThunk)('assetVersion/fetchVersionComments', async (payload, { getState }) => {
    const { assetVersions: { selectedVersion }, } = getState();
    if (!selectedVersion) {
        throw new Error('Missin asset in asset detail slice');
    }
    const { id: assetId } = { ...selectedVersion };
    const response = await pulse_components_1.v2Endpoint.get(window.pulse.config.urls.api, {
        params: {
            action: 'files',
            type: 'comments',
            assetId,
        },
    });
    return response.data.data.map((comment) => ({
        ...comment,
        id: comment.noteId,
    }));
});
exports.deleteComment = (0, toolkit_1.createAsyncThunk)('assetVersion/deleteComments', async (noteId, { rejectWithValue }) => {
    const response = await pulse_components_1.v2Endpoint.get(window.pulse.config.urls.api, {
        params: {
            action: 'files',
            type: 'emailHistory',
            noteId,
        },
    });
    if (!response.data.success) {
        rejectWithValue(new Error('Failed to delete comment'));
    }
    return noteId;
});
exports.assetVersionSlice = (0, toolkit_1.createSlice)({
    name: 'AssetVersions',
    initialState,
    reducers: {
        openVersionCommentsModal: (state) => {
            state.isVersionCommentModalOpen = true;
        },
        closeVersionCommentsModal: (state, action) => {
            const { emptySelectedVersion = true } = { ...action.payload };
            state.isVersionCommentModalOpen = false;
            if (emptySelectedVersion) {
                state.selectedVersion = null;
            }
        },
        setSelectedVersion: (state, action) => {
            state.selectedVersion = action.payload;
            state.isVersionCommentModalOpen = true;
        },
        setAssetVersions: (state, action) => {
            state.versions = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(exports.fetchAssetVersions.pending, (state) => {
            state.isLoadingVersions = true;
        });
        builder.addCase(exports.fetchAssetVersions.fulfilled, (state, action) => {
            state.versions = action.payload;
            state.isLoadingVersions = false;
        });
        builder.addCase(exports.fetchAssetVersions.rejected, (state) => {
            state.isLoadingVersions = false;
        });
        builder.addCase(exports.fetchAssetVersionComments.pending, (state) => {
            state.isLoadingVersionComments = true;
        });
        builder.addCase(exports.fetchAssetVersionComments.fulfilled, (state, action) => {
            state.isLoadingVersionComments = false;
            state.comments = action.payload;
        });
        builder.addCase(exports.fetchAssetVersionComments.rejected, (state) => {
            state.isLoadingVersionComments = false;
            utilities_1.default.notification.danger('Failed to fetch asset version comment');
        });
        builder.addCase(exports.deleteComment.fulfilled, (state, action) => {
            state.comments = state.comments.filter((comment) => comment.noteId !== action.payload.toString());
        });
        builder.addCase(exports.deleteComment.rejected, (state, action) => {
            var _a;
            utilities_1.default.notification.danger((_a = action.payload) === null || _a === void 0 ? void 0 : _a.message);
        });
    },
});
_a = exports.assetVersionSlice.actions, exports.closeVersionCommentsModal = _a.closeVersionCommentsModal, exports.openVersionCommentsModal = _a.openVersionCommentsModal, exports.setAssetVersions = _a.setAssetVersions, exports.setSelectedVersion = _a.setSelectedVersion;
exports.default = exports.assetVersionSlice.reducer;
